<template>
  <v-card>
    <v-toolbar flat>
      <v-toolbar-title>{{ label }}</v-toolbar-title>
      <v-spacer />
      <v-btn v-if="type=='shipping'" small outlined class="mr-2" @click="doCopyBillingAddress()">
        <v-icon small left>mdi-content-copy</v-icon>
        Copy billing
      </v-btn>
      <AddressSelection :type="type" :clientId="customerId" :orderId="orderId" @updated="$emit('updated')"/>
    </v-toolbar>
    <v-card-text v-if="model">
      <v-row>
        <v-col>
          <div v-if="model.company">{{ model.company }}</div>
          <div v-if="model.addressLine1">{{ model.addressLine1 }}</div>
          <div v-if="model.addressLine2">{{ model.addressLine2 }}</div>
          <div v-if="model.city || model.postalCode">{{ model.postalCode }} {{ model.city }}</div>
          <div v-if="model.state || model.country">{{ model.state }} - {{ getCountryName(model.country) }}</div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { getCountryName } from "@/utils/country.js";
import AddressSelection from "../client/AddressSelection.vue";
import { mapActions } from "vuex";

export default {
  components: {
    AddressSelection
},
  props: ["label", "type", "customerId", "orderId", "value", "disabled"],
  data: () => ({
      addresse: null,
      loading: null,
  }),
  computed: {
    model () {
      return this.value
    }
  },
  methods: {
    ...mapActions('orders', ['copyBillingAddress']),
    doCopyBillingAddress () {
      this.copyBillingAddress(this.orderId)
        .then(() => {
          this.$emit('updated')
        })
    },
    getCountryName
  },
};
</script>

<style></style>
